"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enum = void 0;
var types_1 = require("@near-js/types");
Object.defineProperty(exports, "Enum", { enumerable: true, get: function () { return types_1.Enum; } });
